<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent - martin vicencio
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="Kardex (Histórico de calificaciones)" code-toggler>



            <div class="w-full bg-grid-color h-12 flex-start">
                <span class="sm:flex hidden m-auto">
                     <b> Id: ( {{id}} ) Matricula:  {{matricula}} - Nombre: {{ alumno_detalle2.ncompleto}}
                     
                     </b>

                    <!-- Nombre Alumno:  {{matricula['idAlumno']}} -->
                </span>
            </div>




        <vs-table search stripe :data="kardex">

            <template slot="thead">
                <vs-th>Número</vs-th>
                <vs-th>Materia</vs-th>
                <vs-th>Grupo </vs-th>
                 <vs-th>Periodo</vs-th>
                 <vs-th sort-key="aprobada">Aprobada</vs-th>
                <!-- <vs-th>Ordinaria -(Promedio 1er y 2do parcial)</vs-th> -->
                <!-- <vs-th>Regular</vs-th> -->
                <!-- <vs-th>Extraordinario</vs-th> -->
                <vs-th>Calificación <br>
                    (Nota: para el cuatrimestre actual, la calificacion final se muestra hasta el cierre del periodo)</vs-th>

            </template>

         <template slot-scope="{data}">
            <vs-tr :state="data[indextr].aprobada == 'SI' ? 'success':data[indextr].aprobada == 'NO' ? 'danger':null" :key="indextr" v-for="(tr, indextr) in data">
            <!-- <vs-tr :key="indextr" v-for="(tr, indextr) in data"> -->
                <vs-td :data="data[indextr].id">
                 <!-- {{data[indextr].matricula}}-->
                  {{ indextr + 1 }}
                 </vs-td>
                <vs-td :data="data[indextr].nombre_materia">
                    {{data[indextr].nombre_materia}}
                </vs-td>
                <vs-td :data="data[indextr].idCuatrimestre">
                    {{data[indextr].idCuatrimestre}}- {{data[indextr].siglas}}-{{data[indextr].digito}}
                </vs-td>
                <vs-td :data="data[indextr].idAgno">
                    {{data[indextr].nombre_periodo}} {{data[indextr].idAgno}}
                </vs-td>
                <!-- <vs-td :data="data[indextr].id">
                  <div v-if="data[indextr].liberadaSegundoParcial">
                   {{data[indextr].calificacionFinal}}
                 </div> 
                </vs-td>
                <vs-td :data="data[indextr].id">
                    {{data[indextr].calificacionRegular}}
                </vs-td>

                <vs-td :data="data[indextr].id">
                    {{data[indextr].calificacionExtraordinario}}
                </vs-td> -->

         <vs-td :data="data[indextr].id">

                     <div v-if="data[indextr].idAgno >=2022">
                              <div v-if="data[indextr].liberadaSegundoParcial">

                                <!-- <div v-if="data[indextr].finalfinal.substr(0,2) >=7"> -->
                                     <div v-if="data[indextr].calificacionFinalFinal >=7">
                               
                                         {{data[indextr].aprobada='SI' }} 
                                 </div> 
                                      <div v-else >
                                    
                                        {{data[indextr].aprobada='NO' }} 
                                        </div>  
                               </div>
                       </div> 
                            <div v-else >

                                     <!-- <div v-if="data[indextr].finalfinal.substr(0,2) >=7"> -->
                                        <div v-if="data[indextr].calificacionFinalFinal >=7">
                               
                                             {{data[indextr].aprobada='SI' }} 
                                     </div> 
                                         <div v-else >
                               
                                                     {{data[indextr].aprobada='NO' }} 
                                            </div>  
                                   </div>     
                   
                </vs-td>

                <vs-td :data="data[indextr].id">
                    
                <div v-if="data[indextr].idAgno >=2022">
                     <div v-if="data[indextr].liberadaSegundoParcial">
                              <!-- {{data[indextr].finalfinal}} -->
                                {{data[indextr].calificacionFinalFinal}}
                     </div>
                </div> 
                <div v-else >
                  <!-- {{data[indextr].finalfinal}} -->
                  {{data[indextr].calificacionFinalFinal}}
                </div> 

                </vs-td>

            </vs-tr>
        </template>

        </vs-table>
    </vx-card>
</template>

<script>
export default {
    data() {
        return {
            periodos:[
               'Enero-Abril',
               'Mayo-Agosto',
                'Septiembre-Diciembre'
            ],
            id: localStorage.getItem('id'),
            matricula: localStorage.getItem('matricula'),
            kardex: [],
             alumno_detalle2: {}
        }
    },
    created() {
        this.$vs.loading();
        this.getKardex();
            this.getAlumno();

    },
    mounted(){
      //  this.getKardex1();

    },
    // updated(){
    //  //  this.getKardex2();
    // },
    methods: {
        
        getAlumno(){
            this.$http.get("alumno_id/" + this.id).then(
                response => {
                    this.alumno_detalle2 = response.data.alumno;
                //   this.carrera_id=this.alumno_detalle2['idCarrera'];
                //   this.getCarrera(this.carrera_id);

                },
                error => {
                    this.StepError(error);
                }
            );
        },

        getKardex() {
            this.$http.get("kardex_alumno/" + this.id).then(
                response => {
                    // console.log(response.data)
                    this.kardex = response.data.kardex;
                    this.$vs.loading.close();
                    //console.log(this.kardex);
                },
                error => {
                    this.StepError(error);
                }
            );
        }


    },
}
</script>
